import React from 'react';
import PropTypesConfig from 'config/prop-types';
import { ThemeProvider } from 'styled-components';
import slugify from 'util/slugify';
import { __ } from '@wordpress/i18n';
import getResultsGroups from 'services/getResultsGroups';

// Styled components.
import theme from 'styles/theme';
import styles from './styles';

/**
 * A component representing a results card for a race.
 */
export default class RaceGroup extends React.PureComponent {
  /**
   * Set PropTypes for this component.
   * @type {object}
   */
  static propTypes = PropTypesConfig.GROUP_NAV_SHAPE;

  render() {
    // Race Styled Components.
    const {
      GroupNav,
    } = styles;

    const {
      results = [],
    } = this.props;

    // Get list of all groups, if they exists.
    // Will return empty array if nothing exists.
    const visibleGroupResults = getResultsGroups(results);

    return (
      <ThemeProvider theme={theme}>
        <GroupNav aria-labelledby="group-nav">
          <h2 id="group-nav">
            {__('Jump to Results', 'election-hub')}
          </h2>
          <input
            type="checkbox"
            className="caret--input"
            id="toggle__group-nav"
          />
          <label // eslint-disable-line jsx-a11y/label-has-associated-control, no-nesting ok.
            htmlFor="toggle__group-nav"
            className="caret visible-xs"
          >
            <span aria-label={__('Toggle Filter View', 'election-hub')} />
          </label>
          <ul>
            {visibleGroupResults.map((result) => (
              // If group exists in results.
              <li>
                <a href={`#${slugify(result.title)}`}>
                  {result.title}
                </a>
              </li>
            ))}
          </ul>
        </GroupNav>
      </ThemeProvider>
    );
  }
}
